const cardInjectionKey = Symbol("ArcoCard");
export { cardInjectionKey };
